import { SPLoading } from '@group-link-one/gl-ui/sonarprint';
import { Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

import { NotFound } from '../pages';

/**
 * Fallback routes (404 not found)
 */
export const useFallbackRoutes = (): RouteObject[] => {
  return [
    {
      path: '*',
      element: (
        <Suspense fallback={<SPLoading screen='as-full-screen' type='dots' />}>
          <NotFound />
        </Suspense>
      ),
    },
  ];
};
